import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ParentsAttendingParentTeacherMeetings = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Parents attending Parent-Teacher Meetings (%)" />
    </Box>
  );
};
